<div class="h-full overflow-y-auto">
    @if (creatorVideos() === undefined) {
    <atom-loading-inline title="Loading Videos" message="Fetching portfolio videos..."></atom-loading-inline>
    } @else if (creatorVideos()!.length === 0) {
    <div class="flex h-full items-center justify-center px-4">
        <div class="text-center">
            <h3 class="m-0 text-lg font-semibold text-primary">No Videos</h3>
            <p class="m-0 mt-1 text-sm text-secondary">There are no videos eligible for this creator's portfolio.</p>
        </div>
    </div>
    } @else {
    <div class="flex flex-col gap-4">
        <!-- <div class="flex gap-2 overflow-x-auto" role="group" aria-label="Filter portfolio by brand">
            <button type="button" (click)="selectBrand('All')" [class]="brandChipClass('All')">All</button>
            @for (brand of brandNames(); track brand) {
            <button type="button" (click)="selectBrand(brand)" [class]="brandChipClass(brand)">{{ brand }}</button>
            }
        </div> -->

        @if (visibleVideos().length === 0) {
        <p class="m-0 py-16 text-center text-xl font-semibold text-secondary">No portfolio pieces match these filters.</p>
        } @else {
        <ul role="list" class="grid grid-cols-2 gap-3 lg:grid-cols-4 lg:gap-5">
            @for (video of visibleVideos(); track video.id) {
            <li class="flex flex-col gap-2">
                <div class="relative">
                    <mgc-portfolio-inline-video [video]="video" [profileFrame]="true"></mgc-portfolio-inline-video>
                    @if (portfolioPlatformLabel(video.brief?.shoutBrief?.socialPlatform); as platform) {
                    <p class="pointer-events-none absolute top-2 left-2 m-0 rounded-full bg-black px-2 py-1 text-xs font-bold text-white">
                        {{ platform }}
                    </p>
                    }
                    @if (video.brief?.businessAccount?.companyLogo) {
                    <img [src]="imageService.getImageSource(video.brief?.businessAccount?.companyLogo, 'gallery')"
                        alt=""
                        class="pointer-events-none absolute top-2 right-2 size-7 rounded-full border-2 border-white object-cover" />
                    }
                </div>
                <div class="min-w-0">
                    <h3 class="m-0 truncate text-sm font-bold text-primary">{{ portfolioBrandName(video) }}</h3>
                    <p class="m-0 truncate text-xs text-secondary">
                        {{ video.brief?.title || 'Only for portfolio videos' }}
                    </p>
                </div>
            </li>
            }
        </ul>
        }
    </div>
    }
</div>

@if (previewVideo()) {
<atom-single-video-viewer-summary class="z-[999]" [video]="previewVideo()!"
    (closePreviewOut)="previewVideo.set(undefined)"></atom-single-video-viewer-summary>
}
